module.exports = __webpack_public_path__ + "static/22-5c2be6cf049d7d35fcba94ae45d47e6d.jpg";